import { render, staticRenderFns } from "./task-model-view-component-detail.vue?vue&type=template&id=b0434132&scoped=true&"
import script from "./task-model-view-component-detail.vue?vue&type=script&lang=ts&"
export * from "./task-model-view-component-detail.vue?vue&type=script&lang=ts&"
import style0 from "./task-model-view-component-detail.vue?vue&type=style&index=0&id=b0434132&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0434132",
  null
  
)

export default component.exports